/**
 * Games Catalog — add new game entries here to surface them on the landing page.
 * Each game must have a matching server route at /api/game/:id/config.
 */

export const GAMES_CATALOG = [
  {
    id: 'rabbit-rush',
    name: 'Rabbit Rush',
    tagline: 'Hop to glory before the crash!',
    description:
      'Guide your rabbit across lucky platforms. Each step multiplies your bet — but cash out before it crashes!',
    category: 'Crash',
    tags: ['HOT', 'NEW'],
    rtp: '97%',
    minBet: 0.1,
    maxBet: 100,
    volatility: 'High',
    /** Demo params injected into the URL when the player clicks Play Demo */
    demoParams: {
      mode: 'demo',
    },
  },
  // Add future games here, e.g.:
  // {
  //   id: 'coin-flip',
  //   name: 'Coin Flip',
  //   tagline: 'Heads or tails — double or nothing!',
  //   ...
  // }
];

/** Fast lookup by game id */
export const getGameById = (id) => GAMES_CATALOG.find((g) => g.id === id) ?? null;
